import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';

export const RadioContainer = styled.label`
    user-select: none;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: 12px;
    row-gap: 8px;
    margin: 0;
    cursor: pointer;
`;

export const Input = styled.input`
    appearance: none;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border: 1px solid #63666A;
    box-sizing: border-box;
    border-radius: 999px;
    background-color: ${colors.WHITE};
    padding: 4px;
    position: relative;

    &::after {
        content: '';
        width: 12px;
        height: 12px;
        background-color: ${colors.WHITE};
        position: absolute;
        border-radius: 999px;
        top: 3px;
        left: 3px;
        cursor: pointer;
    }

    &:checked {
        border-color: ${colors.BLACK};

        &::after {
            background-color: #FF5F14;
        }

        &:disabled {
            &::after {
                background-color: #AAAAAA;
            }
        }
    }

    &:focus {
        outline: #FFDFD0 solid 5px;
        outline-offset: 0;
        border-color: ${colors.BLACK};
    }

    &:hover:not(:disabled) {
        outline: #FFDFD0 solid 5px;
        border-color: ${colors.BLACK};
    }

    &:disabled {
        border-color: #AAAAAA;

        &::after {
            cursor: not-allowed;
        }
    }
`;

export const Text = styled.p`
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${({ disabled }) => (disabled ? '#63666A' : colors.BLACK)};
    margin: 0;
`;

export const SubLabel = styled.p`
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 3;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${({ disabled }) => (disabled ? '#63666A' : colors.BLACK)};
    margin: 0;
`;
